import type { UserInfo, UserPhoneNumber } from '@entities/user';
import { ControllerFactory } from '@main/factories/controller.factory';
import { RepositoryFactory } from '../factories/repository.factory';

export class CorrectUserInfo {
  static async correct(info: UserInfo): Promise<UserInfo> {
    const controller =
      ControllerFactory.buildStoreIntegrationSettingsController();
    const userRepository = RepositoryFactory.buildMemUserRepository();

    const { defaultOutNumber, phoneNumberIntegrationIdsMap } =
      await controller.handle(info);

    const userPhoneNumber: UserPhoneNumber[] = Object.values(
      phoneNumberIntegrationIdsMap,
    ).map((elm) => elm.phoneNumber);

    info.default_out_number_id = defaultOutNumber;
    info.numbers = userPhoneNumber;

    userRepository.updateUserInfo(info);
    return info;
  }
}
